import { createSlice } from "@reduxjs/toolkit";

// Define initial state for access rights
const initialState = [];

// Create a slice for access rights
const moduleParamJsonSlice = createSlice({
  name: "moduleParamJson",
  initialState,
  reducers: {
    // Action to set access rights
    setmoduleParamJson: (state, action) => {
      console.log("Access payload received:", action.payload);
      return action.payload;
    },
    // Action to clear access rights
    clearmoduleParamJson: () => {
      return [];
    },
  },
});

// Export actions for use in components
export const { setmoduleParamJson, clearmoduleParamJson } = moduleParamJsonSlice.actions;

// Export reducer to be included in the store
export default moduleParamJsonSlice.reducer;
